import * as React from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import PresentationModeContext from 'routes/Dashboard/components/PresentationModeContext';
import { Box } from '@mui/material';
import NestedMenu, { NestedMenuOptionT } from 'ui/NestedMenu/NestedMenu';
import { useMenuItems } from './hooks/menuItems';

interface WidgetMenuProps {
    editMode: boolean;
    canEdit?: boolean;
    menuItems: NestedMenuOptionT[];
    exportMenu?: React.ReactNode;
}

const WidgetMenu = ({
    editMode,
    menuItems,
    canEdit = true,
    exportMenu = null,
}: WidgetMenuProps) => {
    const [presentationMode] = React.useContext(PresentationModeContext);

    const fullMenuItems = useMenuItems(menuItems, canEdit, editMode);
    if (presentationMode) {
        return null;
    }

    const iconMenu = fullMenuItems.length > 0 && (
        <NestedMenu
            button={{
                isIconButton: true,
                iconButton: {
                    iconElement: <MoreVertIcon fontSize="small" />,
                    className: '',
                    color: 'default',
                },
            }}
            menuLevels={2}
            options={fullMenuItems}
            onOptionClick={(option: NestedMenuOptionT) =>
                option.onClick(option.action)
            }
        />
    );
    return (
        <Box sx={{ display: 'flex' }} className="showOnHover">
            {exportMenu} {iconMenu}
        </Box>
    );
};

export default WidgetMenu;
